module.exports = __webpack_public_path__ + "static/media/final_02.0fac2cf3.jpg";